import { axiosFactory } from '../../../../client';
import { NonNationalExamList, RegistrationReportExamList } from '../../model';
import * as ROUTES from './routes';

const candidateBaseURL = `${import.meta.env.VITE_APP_API_DOMAIN}`;
const reportBaseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/reporting/api`;
const timeout = 30000;

export const opsAdminCandidateClient = axiosFactory(candidateBaseURL, timeout);
export const opsAdminReportClient = axiosFactory(reportBaseURL, timeout);

export const getRegistrationReportExamLevel = () =>
  opsAdminCandidateClient.get<RegistrationReportExamList>(
    `${ROUTES.GET_REGISTRATION_REPORT_EXAM_LEVEL}`
  );

export const getNonNationalExamList = () =>
  opsAdminCandidateClient.get<NonNationalExamList>(`${ROUTES.GET_NON_NATIONAL_EXAM_LIST}`);
